import { Tool, type ToolArgsWithController } from '@aha-app/aha-editor-v2';
import jQuery from 'jquery';

class ToolShowHistory extends Tool {
  static toolName = 'View history';
  static iconClass = 'fa-regular fa-clock fa-fw';
  static shortcut = 'Cmd+Shift+h';

  static available(toolArgs: ToolArgsWithController): boolean {
    return Boolean(toolArgs.controller.historyURL);
  }

  static action({ controller }: ToolArgsWithController): void {
    const provider = controller.ahaEditor.getProvider('fullScreen');
    provider?.onSetFullScreen(false);

    jQuery.get(controller.historyURL);
  }
}

export default ToolShowHistory;
